import { PageType } from '../../../typedefs';
import { UpdatePageInput } from '../UpdatePage.typedefs';

const TRY_AGAIN_HINT_MESSAGE = 'update_page_form_content_hint_try_again';

const SERIAL_NUMBER_POPUP_HINT_BY_FIELD_NAME: Record<string, string> = {
  [UpdatePageInput.NOT_FOUND_MESSAGE]: TRY_AGAIN_HINT_MESSAGE,
};

const HINTS_BY_PAGE: Record<string, Record<string, string>> = {
  [PageType.SERIAL_NUMBER_POPUP]: SERIAL_NUMBER_POPUP_HINT_BY_FIELD_NAME,
};

export const getUpdatePageContentHintMessage = (pageType: PageType, fieldName: string) => {
  return HINTS_BY_PAGE[pageType]?.[fieldName];
};
